@use '@lib/assets/styles/main.scss' as *;

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}

.root {
  padding: 0;
  margin: 0;
  z-index: 0;
  overflow: hidden;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: 0.3s ease all;
  cursor: default;
  max-width: 100%;

  &.disabled {
    cursor: not-allowed;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &.asBlockElement {
    display: flex;
  }

  &.hasLabel {
    .leftIcon, [class*='leftIcon'], .leftImage {
      margin-left: -8px;
      margin-right: 4px;
    }

    .rightIcon, [class*='rightIcon'] {
      margin-right: -8px;
      margin-left: 4px;
    }
  }

  .leftIcon, [class*='leftIcon'], .leftImage {
    img, svg {
      display: block;
    }
    svg {
      width: 16px;
      height: auto;
    }
  }

  .leftImage {
    display: block;
    width: 24px;
    height: 24px;
    object-fit: cover;
  }

  .leftImageRounded {
    border-radius: 50%;
  }

  .chipContent {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: opacity .3s ease;
    max-width: 100%;
  }

  .chipText {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chipTextStrikethrough {
    text-decoration: line-through;
  }

  .chipCounter {
    color: $gray0;
    border-radius: 10px;
    background-color: $blue500;
    padding: 0 4px;
    min-width: 20px;
    line-height: 20px;
    margin-left: 8px;
    & > * {
      line-height: inherit;
      display: block;
    }
  }

  .rightIcon {
    position: relative;
    z-index: 1;
  }
}

.pointer {
  cursor: pointer;
}
